"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IButtonProps", {
  enumerable: true,
  get: function get() {
    return _ButtonOld.IButtonProps;
  }
});
Object.defineProperty(exports, "Variant", {
  enumerable: true,
  get: function get() {
    return _ButtonOld.Variant;
  }
});
exports["default"] = void 0;
var _Button = _interopRequireDefault(require("./Button.middleware"));
var _ButtonOld = require("./old/Button.old.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = _Button["default"];